







































































import Vue from "vue";
import { SearchAPIModels } from "search-api-client";

import FilterDropDown from "./FilterDropDown.vue";
import DateFilterDropDown from "./DateFilterDropDown.vue";
import MoreFilterDropDown from "./MoreFilterDropDown.vue";

export default Vue.extend({
  name: "Filters",
  props: {
    tagGroups: {
      type: Object as () => SearchAPIModels.GenericSearchResponseFacets,
      required: true,
      default: {},
    },
    tags: {
      type: Array as () => SearchAPIModels.TaxonomyTag[],
      required: true,
      default: [],
    },
    datetags: {
      type: Array as () => SearchAPIModels.GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: [],
    },
    showYearFilter: {
      type: Boolean,
      required: true,
      default: false,
    },
    filtergroupids: {
      type: Array as () => string[],
      required: false,
      default: [],
    },
  },
  watch: {
    tagGroups: function(val) {
      this.activeGroup = this.restrictCategories(
        this.filtergroupids,
        0,
        val.taxonomy.length - 1,
        val.taxonomy
      ).map((x) => false);
    },
  },
  data() {
    return {
      activeGroup: this.$props.filtergroupids.map((x) => false) as boolean[],
      showmore: false as boolean,
    };
  },
  components: {
    FilterDropDown,
    DateFilterDropDown,
    MoreFilterDropDown,
  },
  computed: {
    tabIndexMore() {
      return this.showmore ? 0 : -1;
    },
  },
  methods: {
    restrictCategories(
      ids: string[],
      start: number,
      end: number,
      catergories?: SearchAPIModels.TaxonomyCategory[]
    ): SearchAPIModels.TaxonomyCategory[] {
      if (catergories !== undefined) {
        const eoa = end <= catergories.length ? end : catergories.length;
        if (ids !== undefined && ids.length <= 1)
          return catergories.filter(function(
            cat: SearchAPIModels.TaxonomyCategory,
            index: number
          ) {
            return index < end && index >= start;
          });
        if (!catergories) return [];
        return catergories.filter(function(
          cat: SearchAPIModels.TaxonomyCategory,
          index: number
        ) {
          return (
            ids.includes(cat.id.toString()) && index < end && index >= start
          );
        });
      }
      return [];
    },
    showMoreFilters() {
      if (this.$data.showmore) {
        if (this.$data.activeGroup.filter((x) => x === true).length === 0) {
          this.$emit("toggleFilters", false);
        } else {
          this.$emit("toggleFilters", true);
        }
      } else {
        this.$data.activeGroup = this.$props.filtergroupids.map((x) => false);
        this.$emit("toggleFilters", true);
      }

      this.$data.showmore = !this.$data.showmore;
    },
    closeFilter(index: number) {
      this.$data.activeGroup = this.$props.filtergroupids.map((x) => false);
      this.$emit("toggleFilters", false);
    },
    toggleFilters(index: number, isOpen: boolean) {
      if (isOpen) {
        this.$data.activeGroup = this.$props.filtergroupids.map((x) => false);
        if (
          this.$data.activeGroup.filter((x) => x === true).length === 0 &&
          !this.$data.showmore
        ) {
          this.$emit("toggleFilters", false);
        }
      } else {
        this.$set(this.$data.activeGroup, index, true);
        this.$emit("toggleFilters", true);
      }
    },
    addFilter(tag: SearchAPIModels.TaxonomyTag) {
      if (this.tags.filter((x) => x.id === tag.id).length === 0) {
        this.tags.push(tag);
        this.$emit("change", this.tags);
      } else {
        for (let i = 0; i <= this.tags.length - 1; i++) {
          if (this.tags[i].id === tag.id) {
            this.tags.splice(i, 1);
          }
        }
        this.$emit("change", this.tags);
      }
    },
    addDateFilter(tag: SearchAPIModels.GenericSearchResponseFacetsCreatedItem) {
      if (this.$props.datetags === undefined) return false;
      if (this.datetags.filter((x) => x.value === tag.value).length === 0) {
        this.datetags.push(tag);
        this.$emit("changeDate", this.datetags);
      } else {
        for (let i = this.datetags.length - 1; i >= 0; --i) {
          if (this.datetags[i].value === tag.value) {
            this.datetags.splice(i, 1);
          }
        }
        this.$emit("changeDate", this.datetags);
      }
    },
  },
});
